import Grid from "@mui/material/Unstable_Grid2";
import './legal.css';

const TosPage = () => {
    return (
        <Grid container spacing={2} sx={{ml: 2, mt: 5, mr: 2, mb: 2}}>
            <Grid xs={12} sm={10} md={8} lg={6}>
                <h1>Terms of Service</h1>
                <p><strong>Email Contact:</strong> support&#64;nasbai.com</p>
            </Grid>

            <Grid>
                <section>
                    <h2>1. Acceptance of Terms</h2>
                    <p>By registering for and using Nasbai you agree to these Terms of Service ("Terms"). If you do not
                        agree with any part of these Terms, you must not use the service.</p>
                </section>

                <section>
                    <h2>2. Eligibility</h2>
                    <ul>
                        <li>
                            <strong>Geographical Scope for Free Service:</strong> Nasbai is primarily intended for users
                            residing within the European Union (EU). While efforts are made to ensure compliance with EU
                            regulations, access and functionality for users outside the European Union are not
                            guaranteed, and may be limited or unavailable. By using Nasbai, you confirm that you are
                            located in the European Union.
                        </li>
                        <li><strong>Users in Germany and the European Union:</strong> If you are a consumer residing in
                            Germany or
                            another
                            European Union member state and are under 16 years old, your use of Nasbai and the
                            processing of
                            your personal data is only permissible with the express consent or authorization of your
                            parent or
                            legal guardian. We reserve the right to implement reasonable efforts to verify such consent,
                            taking
                            into consideration available technology. By using Nasbai, you confirm that you meet these
                            eligibility requirements or have obtained the necessary parental/guardian consent.
                        </li>

                        <li><strong>Account Responsibility:</strong> To access and use Nasbai, you must register and
                            create an account.
                            You are
                            responsible for maintaining the confidentiality of your login information and for all
                            activities
                            that occur under your account. You agree to notify us immediately of any unauthorized use of
                            your
                            account or any other breach of security. We are not liable for any loss or damage arising
                            from your
                            failure to comply with this security obligation.
                        </li>
                    </ul>
                </section>

                <section>
                    <h2>3. User Content</h2>
                    <p>Nasbai allows you to upload, listen to, and share audio content consisting of nature sounds. You
                        can also create a profile with a bio and links to your social media accounts.</p>
                    <ul>
                        <li>
                            <strong>Licensing Requirement:</strong> All audio uploaded to Nasbai must be properly
                            licensed under one of the following accepted open content licenses:
                            <ul>
                                <li>Creative Commons Attribution-ShareAlike 4.0 International (CC BY-SA 4.0)</li>
                                <li>Creative Commons Attribution 4.0 International (CC BY 4.0)</li>
                                <li>Creative Commons Zero 1.0 Universal (CC0 1.0)</li>
                            </ul>
                            By uploading content, you represent and warrant that you have all necessary rights to
                            license your content under one of the above licenses. Nasbai will display the selected
                            license clearly with your content, and all users must respect those license terms when using
                            or redistributing your audio.
                        </li>
                        <li>
                            By uploading content, you represent and warrant that the audio recordings you submit do not
                            infringe upon any third-party rights, including copyrights, related rights, or other
                            intellectual property rights. This obligation applies regardless of any open content license
                            labels applied to the recordings, which do not legitimize or cure any legal infringement.
                            You bear sole responsibility for ensuring the legality of the content you upload.
                        </li>

                        <li>
                            <strong>Profile Creation:</strong> You can create a user profile that includes a bio and
                            links to your social media accounts. By creating a profile, you agree to provide accurate
                            and up-to-date information.
                        </li>
                        <li>
                            <strong>Content Responsibility:</strong> You are solely responsible for the content you
                            upload and share on Nasbai. You must ensure that your content does not violate any
                            applicable laws or infringe on the rights of others.
                        </li>
                        <li>
                            <strong>Content Removal:</strong> We reserve the right to remove any content that violates
                            these Terms or is deemed inappropriate at our sole discretion. If you believe your content
                            was removed in error, you may contact us at support&#64;nasbai.com.
                        </li>
                        <li>
                            <strong>Platform License:</strong> By uploading content to Nasbai, you grant us a
                            non-exclusive, worldwide, royalty-free license to use, reproduce, modify, adapt, publish,
                            reformat, transcode, or otherwise technically adapt,
                            translate, distribute, and display your content solely for the purpose of operating and
                            providing the Nasbai service. This license does not affect your ownership of the content or
                            the terms of the license you selected.
                        </li>
                    </ul>
                    <h3>3.1 Content Review and Moderation</h3>
                    <p>
                        All audio content uploaded to Nasbai undergoes a manual pre-approval process before it is
                        published on the platform. We verify that the submitted recordings consist exclusively of nature
                        sounds and that they are properly licensed under one of the accepted open licenses (e.g., CC
                        BY-SA 4.0, CC BY 4.0, CC0 1.0).
                    </p>
                    <p>
                        Content that does not meet these requirements will be rejected or removed. Users will be
                        notified in case of rejection. We reserve the right to revoke approval at any time if new
                        information indicates a violation of our Terms of Service or licensing rules.
                    </p>
                    <p>
                        Users can report any published content that appears to violate these Terms by using the
                        reporting function or by contacting support@nasbai.com. Repeated or serious violations may
                        result in suspension or termination of user accounts.
                    </p>

                </section>

                <section>
                    <h2>4. Premium Subscriptions</h2>
                    <p>
                        Users can optionally purchase a paid Premium Subscription, which grants access to exclusive,
                        non-essential digital features designed to enhance the user experience. For tax and compliance
                        reasons, Premium Subscriptions are currently only available for
                        purchase by users located within the European Union.
                    </p>
                    <h3>4.1 Subscription and Payment Processing</h3>
                    <p>
                        Paid subscriptions are processed securely via PayPal. Nasbai does not store or
                        directly process your payment information. By purchasing a subscription, you agree to the
                        applicable terms and conditions of PayPal, including their policies on payment processing,
                        refunds, and dispute resolution. You enter into a direct contract with Nasbai for the delivery
                        of digital services.
                    </p>

                    <h3>4.2 Features Included in the Premium Subscription</h3>
                    <ul>
                        <li><strong>Exclusive supporter Badge</strong></li>
                        <li><strong>Unlimited custom Playlists</strong></li>
                        <li><strong>Early access to new Features</strong></li>
                    </ul>
                    <p>
                        These features are optional and do not affect access to Nasbai’s primary services such as
                        Browse, listening, or uploading licensed nature audio content.
                    </p>

                    <h3>4.3 Right of Withdrawal (EU Consumers)</h3>
                    <p>
                        If you are a consumer residing in the European Union, you have the right to withdraw from your
                        subscription within 14 days of purchase without giving any reason, in accordance with
                        Directive 2011/83/EU and § 355 BGB.
                    </p>
                    <p>
                        The right of withdrawal may expire prematurely if:
                    </p>
                    <ul>
                        <li>You have expressly consented to the immediate provision of the digital service; and</li>
                        <li>You have acknowledged that you lose your right of withdrawal once the provision has begun.
                        </li>
                    </ul>
                    <p>
                        This consent and acknowledgment will be obtained during the checkout process.
                    </p>

                    <h3>4.4 Subscription Management and Cancellation</h3>
                    <p>
                        You may cancel your subscription at any time via the user account settings on Nasbai or
                        in the footer of Nasbai at Cancel Subscription.
                        Cancellations take effect at the end of the current billing period. You will retain access to
                        the Premium features until the subscription expires.
                    </p>
                    <p>
                        In exceptional circumstances, you may request an extraordinary cancellation.
                        Nasbai reserves the right to approve such cancellations on a case-by-case basis.
                        Unless otherwise required by applicable law (e.g., in case of defective or undelivered services),
                        no refund will be provided for the unused portion of the subscription period.
                    </p>

                    <h3>4.5 Legal and Tax Obligations</h3>
                    <p>
                        Nasbai fulfills all applicable legal and tax obligations relating to income generated from
                        Premium Subscriptions in accordance with German tax law. Receipts or invoices are provided
                        automatically after each payment or upon request.
                    </p>
                </section>


                <section>
                    <h2>5. Prohibited Conduct</h2>
                    <p>By using Nasbai, you agree not to engage in any of the following prohibited activities:</p>
                    <ul>
                        <li>Upload or share any audio content for which you do not hold the necessary rights or which is
                            not licensed under one of the explicitly accepted licenses (e.g., CC BY-SA 4.0, CC BY 4.0,
                            CC0 1.0).
                        </li>
                        <li>Upload or share any audio that does not consist of genuine nature sounds, or that includes
                            music, speech, or synthetic audio unless explicitly permitted by Nasbai in writing.
                        </li>
                        <li>Violate any applicable local, national, or international laws or regulations.</li>
                        <li>Harass, threaten, defraud, stalk, or otherwise harm other users or third parties.</li>
                        <li>Upload or distribute content that is illegal, defamatory, obscene, hateful, discriminatory,
                            or infringes upon the intellectual property, privacy, or other rights of others.
                        </li>
                        <li>Use automated tools, scripts, bots, or other unauthorized means to access, manipulate, or
                            interact with the Nasbai platform or its users.
                        </li>
                        <li>Attempt to gain unauthorized access to the service, user accounts, or backend systems.</li>
                        <li>Use the platform for any commercial purposes, including advertising, promotion, or sale of
                            goods or services, without our prior written consent.
                        </li>
                        <li>Introduce or distribute malicious software, including viruses, trojans, worms, or other
                            harmful code.
                        </li>
                        <li>Interfere with, disrupt, or attempt to degrade the availability, performance, or security of
                            Nasbai or any related infrastructure.
                        </li>
                        <li>
                            Using the service to test credit card numbers or engage in any form of payment fraud.
                        </li>
                        <li>
                            Accessing or attempting to access content or features of the Premium Subscription without a
                            valid, active subscription acquired through authorized channels
                        </li>
                    </ul>

                </section>


                <section>
                    <h2>6. Statutory Rights for Digital Services, Warranties, and Limitations of Liability</h2>
                    <h3>6.1 Statutory Rights for Digital Services (For German/EU Consumers)</h3>
                    <p>
                        If you are a consumer residing in Germany or the European Union, your rights regarding the
                        provision of digital services (including the Premium Membership) are primarily governed by
                        statutory law. We are obligated to provide you with a digital service that is free from factual
                        and legal defects.
                    </p>
                    <h3>6.2 Updating Obligation (For German/EU Consumers)</h3>
                    <p>
                        If you are a consumer residing in Germany or the European Union, we are obliged to provide you
                        with updates, including security updates, that are necessary to maintain the conformity of the
                        digital service for the entire duration of its provision. We will inform you about the
                        availability of such updates. You are responsible for installing these updates. If you fail to
                        install an update provided by us within a reasonable time after being informed of its
                        availability and the consequences of not installing it, we shall not be liable for any defect
                        resulting solely from the lack of that update, provided that we have correctly informed you and
                        the failure to install was not due to deficiencies in the installation instructions provided by
                        us.
                    </p>
                    <h3>6.3 Disclaimers and Limitations of Liability (General)</h3>
                    <p>
                        Except for the statutory rights and obligations mentioned above (particularly for consumers in
                        Germany and the EU) and to the maximum extent permitted by applicable law, Nasbai is provided on
                        an "as is" and "as available" basis, without any express or implied warranties of any kind,
                        including but not limited to implied warranties of merchantability, fitness for a particular
                        purpose, or non-infringement.

                        Nasbai does not warrant that the service will be uninterrupted, secure, or error-free. We strive
                        to correct defects promptly, but we do not guarantee immediate correction.

                        Our liability for damages will be limited as follows:

                        We shall be liable without limitation for damages resulting from intent or gross negligence,
                        injury to life, body, or health.
                        For damages caused by the breach of essential contractual obligations (cardinal duties) due to
                        simple negligence, our liability shall be limited to the typically foreseeable damage. Essential
                        contractual obligations are those whose fulfillment is essential to the proper execution of the
                        contract and on whose observance the contracting party regularly relies and may rely.
                        Any further liability for damages is excluded, unless otherwise provided by mandatory statutory
                        law.

                        This limitation of liability also applies to the personal liability of our employees,
                        representatives, and agents.
                    </p>
                </section>

                <section>
                    <h2>7. Intellectual Property Rights</h2>
                    <p>
                        While you retain ownership of the content you upload, by uploading copyleft nature sounds to
                        Nasbai, you grant Nasbai a worldwide, non-exclusive, royalty-free license to host, display, and
                        distribute your content for the purpose of operating and providing the Nasbai service. This
                        license is subject to the specific copyleft license you apply to your audio content.

                        You acknowledge that Nasbai and its licensors own all rights, title, and interest in and to the
                        service, including all intellectual property rights (except for user-generated content uploaded
                        under copyleft licenses). You agree not to copy, modify, distribute, sell, or lease any part of
                        our services or software, nor may you reverse engineer or attempt to extract the source code of
                        that software, unless laws prohibit those restrictions or you have our written permission.
                    </p>

                    <h3>7.1 Copyleft Nature Sounds</h3>
                    <p>All audio uploaded to Nasbai must be of a copyleft nature. This means you must have the necessary
                        rights to upload the content and grant others the right to use, modify, and distribute your
                        content under terms that require any derivative works to be licensed under the same or
                        compatible terms. <strong>Examples of acceptable copyleft licenses include, but are not limited
                            to, Creative Commons Attribution-ShareAlike (CC BY-SA) licenses (e.g., CC BY-SA 4.0
                            International).</strong> You are solely responsible for the content you upload and its
                        adherence to copyleft licenses.</p>
                </section>

                <section>
                    <h2>8. Privacy Policy</h2>
                    <p>Your data is handled in accordance with our <a href="/privacy-policy">Privacy Policy</a> which is
                        an
                        integral part of these Terms of Service.</p>
                </section>

                <section>
                    <h2>9. Modification and Termination</h2>
                    <p>We reserve the right to modify these Terms at any time. We will notify you of any significant
                        changes via email at least 14 days before they take effect. Your continued use
                        of the service after such changes have been made constitutes your acceptance of the revised
                        Terms. If you do not agree with the changes, you may terminate your account as described in
                        Section 11.

                        We may also suspend or terminate your account for violations of these Terms or for other
                        legitimate reasons, such as extended inactivity, in accordance with applicable legal
                        provisions.</p>
                </section>

                <section>
                    <h2>10. Governing Law and Jurisdiction</h2>
                    <p>These Terms are governed by the laws of the Federal Republic of Germany. For consumers residing
                        within the European Union, this choice of law does not deprive them of the protection afforded
                        by
                        provisions that cannot be derogated from by agreement under the law of the country where they
                        habitually reside.</p>
                    <p>For disputes arising from these Terms, the exclusive jurisdiction for commercial entities and
                        where legally permissible for consumers is Ulm, Germany. If you are a consumer residing
                        in the European Union, this choice of jurisdiction does not affect your right to bring
                        proceedings in the courts of your habitual residence, nor does it affect our obligation to bring
                        proceedings against you only in the courts of your habitual residence, in accordance with
                        applicable EU and national consumer protection laws.
                    </p>
                    <p>The contract language is English.</p>
                </section>


                <section>
                    <h2>11. Termination of Contract</h2>
                    <p>You can terminate your account at any time by deleting your account through your profile page or
                        by contacting us at support@nasbai.com. Upon termination, your account and all associated data
                        will be deleted in accordance with our Privacy Policy. For Premium Memberships, please refer to
                        the specific cancellation terms in Section 4.4.</p>
                </section>

                <section>
                    <h2>12. Online Dispute Resolution</h2>
                    <p>We are neither obliged nor willing to participate in dispute resolution proceedings before a
                        consumer arbitration board.
                        The European Commission provides a platform for online dispute resolution (ODR), which you can
                        find at https://ec.europa.eu/consumers/odr/</p>
                </section>

                <section>
                    <h2>13. Saving of Contract Text</h2>
                    <p>We save the text of the contract and send you the order data and our Terms of Service by email.
                        You
                        can also view and print the Terms of Service at any time on this page.</p>
                </section>
                <section>
                    <h2>14. Contact</h2>
                    <p>If you have questions about these Terms, please contact us at tos&#64;nasbai.com.</p>
                </section>

            </Grid>
        </Grid>

    );
}

export default TosPage;